import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col
} from "reactstrap";

import axios from "axios";

import { Redirect } from "react-router-dom";

import { PanelHeader, Button } from "components";

import { thead, tbody } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
import { dashboardPanelChart } from "variables/charts.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

var dashboardOrdersTitleStyle = 
{
  margin:"0 0 20px 20px", 
  color: "#FFF"
};
var facturasDevueltas = [];

class BillsList extends React.Component {
  constructor(props) {
    super(props);
    this.formButton = React.createRef();
    this.state = {
      downloading: {},
      showDetail: false,
      orderDetail: null,
      ordersChartReady: false,
      ordersHistoryTitle: "Histórico de facturas",
      toDashboard: false,
      isPaymentLaunched: false,
      orderIdPayment: "",
      popUp: null,
      buttonReference: null
    };
    //console.log(props);
    this.viewOrderArticles = this.viewOrderArticles.bind(this);
    this.loadOrdersChart = this.loadOrdersChart.bind(this);
    this.startPayment = this.startPayment.bind(this);
    this.isPaymentInProgress = this.isPaymentInProgress.bind(this);
    this.redirectToPayment = this.redirectToPayment.bind(this);
    this.showPaymentResult = this.showPaymentResult.bind(this);
  }
  startPayment(order_id) {
    if (this.isPaymentInProgress()) {
      this.props.startPayment(false);
    } else {
      this.props.startPayment(order_id);
      this.setState({
        orderIdPayment: order_id
      });
    }
  }
  redirectToPayment() {
    this.state.buttonReference.click();
    this.setState({
      isPaymentLaunched: true,
      popUp: null
    });
  }
  showPaymentResult(payment_status) {
    // console.log("#### MOSTRANDO NOTIFICACION (payment_status) ####");
    // console.log(payment_status);
    switch (parseInt(payment_status)) {
      case 223:
        this.paymentOkConfirmation();
        break;
      case 224:
        this.paymentKoConfirmation();
        break;
      default:;
    }
  }
  paymentOkConfirmation() {
    // console.log("#### MOSTRANDO NOTIFICACION PAGO FINALIZADO ####");
    this.setState({
      isPaymentLaunched: false,
      orderIdPayment: "",
      popUp: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-150px" }}
          title="¡Pago completado!"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          El pago ha sido confirmado
        </SweetAlert>
      )
    });
  }
  paymentKoConfirmation() {
    // console.log("#### MOSTRANDO NOTIFICACION PAGO RECHAZADO ####");
    this.setState({
      isPaymentLaunched: false,
      orderIdPayment: "",
      popUp: (
        <SweetAlert
          danger
          style={{ display: "block", marginTop: "-150px" }}
          title="¡Pago rechazado!"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          El pago ha sido rechazado o cancelado
        </SweetAlert>
      )
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (!this.state.isPaymentLaunched && !this.state.popUp && this.formButton && this.formButton.current && this.formButton.current.children[0]) {
      // console.log("#### PAYMENT DID UPDATE ####");
      // console.log(this.formButton.current.children[0].children[3]);

      // this.formButton.current.children[0].children[3].click();
      let redirectNotification = 
        <SweetAlert
          style={{ display: "block", marginTop: "-150px" }}
          title="Proceso de pago"
          onConfirm={() => this.redirectToPayment()}
          // onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="primary"
          // cancelBtnBsStyle="default"
          confirmBtnText="Aceptar"
          // cancelBtnText="Cancelar"
          // showCancel
        >
          <Row>
            <Col xs={3}>
              <div>
                <FontAwesomeIcon icon={['far', 'credit-card']} size="3x" />
              </div>
            </Col>
            <Col xs={9} className="text-left">
              <span>Ahora, te vamos a redirigir a la pasarela de pago de tu banco para que lo realices con tu tarjeta</span>
            </Col>
          </Row>
        </SweetAlert>;
      this.setState({
        popUp: redirectNotification,
        buttonReference: this.formButton.current.children[0].children[3]
      });
    }
    if (this.state.isPaymentLaunched && this.state.orderIdPayment in this.props.mainState.paymentStatuses) {
      let currentPaymentStatus = this.props.mainState.paymentStatuses[this.state.orderIdPayment];
      if (currentPaymentStatus.payment_status != 222) {
        // console.log("#### CONFIRMANDO PAGO EN BILL LIST (currentPaymentStatus.payment_status) ####");
        // console.log(currentPaymentStatus.payment_status);
        this.showPaymentResult(currentPaymentStatus.payment_status);
        setTimeout(function() {
          //Start the timer
          this.props.cleanPaymentStatuses(); //After 2 second, re-check the payment
        }.bind(this),1000);
      }
    }
  }
  isPaymentInProgress() {
    let result = false;
    Object.keys(this.props.mainState.paymentStatuses).map(value => {
      if (this.props.mainState.paymentStatuses[value].payment_status === 222) result = true;
    });
    return result;
  }
  loadOrdersChart() {
    let ordersChartDates = [];
    let ordersChartTotals = [];
    let partialOrders = [];
    /* if(this.props.mainState.orders.length > this.state.ordersToDisplayInChart) {
      partialOrders = this.props.mainState.orders.slice(0,this.state.ordersToDisplayInChart).reverse();
    }else{ */
      partialOrders = this.props.mainState.orders.slice(0).reverse();
    /* } */
    partialOrders.map((currentOrder, key) =>{
      ordersChartDates.push(
        new Intl.DateTimeFormat("es-ES", {
          year: "numeric",
          month: "short"
        })
          .format(Date.parse(currentOrder.fecha))
          .replace(".", "")
      );
      ordersChartTotals.push(
        parseFloat(
          currentOrder.total
            .replace(",", ".")
            .substring(0, currentOrder.total.length - 2)
        )
      );
    });

    let ordersChart = {
      data: canvas => {
        const ctx = canvas.getContext("2d");
        var chartColor = "#FFFFFF";
        var gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
        gradientStroke.addColorStop(0, "#80b6f4");
        gradientStroke.addColorStop(1, chartColor);
        var gradientFill = ctx.createLinearGradient(0, 200, 0, 50);
        gradientFill.addColorStop(0, "rgba(128, 182, 244, 0)");
        gradientFill.addColorStop(1, "rgba(255, 255, 255, 0.14)");
    
        return {
          labels: ordersChartDates,
          datasets: [
            {
              label: "Total",
              borderColor: chartColor,
              pointBorderColor: chartColor,
              pointBackgroundColor: "#2c2c2c",
              pointHoverBackgroundColor: "#2c2c2c",
              pointHoverBorderColor: chartColor,
              pointBorderWidth: 1,
              pointHoverRadius: 7,
              pointHoverBorderWidth: 2,
              pointRadius: 5,
              fill: true,
              backgroundColor: gradientFill,
              borderWidth: 2,
              data: ordersChartTotals
            }
          ]
        };
      },
      options: {
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0
          }
        },
        maintainAspectRatio: false,
        tooltips: {
          backgroundColor: "#fff",
          titleFontColor: "#333",
          bodyFontColor: "#666",
          bodySpacing: 4,
          xPadding: 12,
          mode: "nearest",
          intersect: 0,
          position: "nearest"
        },
        legend: {
          position: "bottom",
          fillStyle: "#FFF",
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 10,

                // Return an empty string to draw the tick line but hide the tick label
                // Return `null` or `undefined` to hide the tick line entirely
                userCallback: function(value, index, values) {
                    // Convert the number to a string and splite the string every 3 charaters from the end
                    value = value.toString();
                    value = value.split(/(?=(?:...)*$)/);
        
                    // Convert the array to a string and format the output
                    value = value.join('.');
                    return value + ' €';
                }
              },
              gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: "rgba(255,255,255,0.1)",
                zeroLineColor: "transparent"
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
                color: "rgba(255,255,255,0.1)"
              },
              ticks: {
                padding: 10,
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold"
              }
            }
          ]
        }
      }
    };

    let firstOrderDate = 
      new Intl.DateTimeFormat("es-ES", {
        year: "numeric",
        month: "short"
      })
        .format(Date.parse(partialOrders[0].fecha))
        .replace(".", "");
    let lastOrderDate = 
      new Intl.DateTimeFormat("es-ES", {
        year: "numeric",
        month: "short"
      })
        .format(Date.parse(partialOrders[partialOrders.length-1].fecha))
        .replace(".", "");

    this.setState({
      ordersChartReady: true,
      ordersChart: ordersChart,
      ordersHistoryTitle: "Histórico de facturas (" + firstOrderDate + " - " + lastOrderDate + ")"
    });
  }
  downloadBill(url, orderNumber, event){
    this.setState({
      [orderNumber]: true
    });
    axios({
      url: url,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        "download",
        "factura_nadunet_".concat(orderNumber).concat(".pdf")
      );
      document.body.appendChild(link);
      link.click();
      this.setState({
        [orderNumber]: false
      });
    });
  }
  hideAlert() {
    this.setState({
      popUp: null
    });
  }
  goToDashboard() {
    this.setState({
      toDashboard: true
    });
  }
  paymentStatus(order){
    let statusReady = null;
    let payment = order.estado_pedido;
    let statusButtonColor = "default";
    let statusButtonIcon = "now-ui-icons ui-2_time-alarm";
    if (payment.includes("Pendiente")) {
      statusButtonColor = "warning";
      statusButtonIcon = "now-ui-icons ui-2_time-alarm";
    } else if(payment.includes("Pagada")){
      statusButtonColor = "primary";
      statusButtonIcon = "now-ui-icons ui-1_check";
    } else if(payment.includes("Procesando")){
      statusButtonColor = "info";
      statusButtonIcon = "now-ui-icons arrows-1_refresh-69 spin";
    } else /*if(payment.includes("Recibo"))*/{
      statusButtonColor = "danger";
      statusButtonIcon = "now-ui-icons ui-1_simple-remove";
    }

    if (payment == "Recibo devuelto") facturasDevueltas.push(order);

    statusReady =                   
    <Button
      color={statusButtonColor}
      size="sm"
      /*onClick={() => {this.openBillStatusPopUpFromBill(order)}}*/
    >
      <i className={statusButtonIcon} /> {payment}
    </Button>;

    return statusReady;
  }
  downloadButton(order){
    let button = 
      <div>
        <i className="now-ui-icons arrows-1_cloud-download-93" /> PDF
      </div>;

    if(this.state[order]){
      button = 
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>;
    }

    return button;
  }
  payButton(order){
    let isPaymentActive = false;
    if (order.id in this.props.mainState.paymentStatuses) isPaymentActive = true;
    let buttonColor = "warning";
    let buttonContent = 
      <div>
        <FontAwesomeIcon icon={['fas', 'circle-notch']} /*size="3x"*/ spin /> Procesando pago
      </div>;
    if (!isPaymentActive) {
      buttonColor = this.isPaymentInProgress() ? "default" : "primary";
      buttonContent =
        <div>
          <i className="now-ui-icons shopping_credit-card" /> Pagar con tarjeta
        </div>;
    }
    let button = 
      <Button
        color={buttonColor}
        size="sm"
        onClick={() => this.startPayment(order.id)}
      >
        {buttonContent}
      </Button>;

    return button;
  }
  viewOrderArticles(order){
    let orderDetailContent =
      <div>
        <Table responsive>
          <thead>
            <tr className="text-primary">
              <th className="text-center">
                Concepto
              </th>
              <th className="text-center">
                Precio
              </th>     
            </tr>
          </thead>
          <tbody>
            {this.props.mainState.ordersArticles[order].map((article, key) => {
              return (
                <tr key={key}>
                  <td className="text-center">{article.titulo}</td>
                  <td className="text-center">{article.total}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>;
    this.setState({
      orderDetail: orderDetailContent,
      showDetail: true
    })
  }
  render() {
    // console.log("#### PAYMENT STATUSES ####");
    // console.log(this.props.mainState.paymentStatuses);
    // console.log("#### BILL LIST STATE ####");
    // console.log(this.state);
    facturasDevueltas = [];
    if (this.state.toDashboard === true) {
      return <Redirect to="/dashboard" />;
    }

    if (this.props.mainState.ordersLoaded && !this.state.ordersChartReady && this.props.mainState.orders.length > 0) this.loadOrdersChart();
    let contentToDisplay = null;
    let contentToPayToDisplay = null;
    let arrayContentsToDisplay = [];
    let ordersToDisplay = [];
    let ordersToPayToDisplay = [];
    let paymentForm = null;
    if (!this.state.isPaymentLaunched && this.state.orderIdPayment > 0 && this.state.orderIdPayment in this.props.mainState.paymentStatuses) {
      paymentForm = 
        <div
          ref = { this.formButton }
          style={{ display: "none" }}
          dangerouslySetInnerHTML={{
            __html: this.props.mainState.paymentStatuses[
              this.state.orderIdPayment
            ].form
          }}
        />;
    }
    if(this.props.mainState.ordersLoaded && this.props.mainState.orders.length > 0){
      
      ordersToDisplay = this.props.mainState.orders.slice(0).map(bill => {
        if (bill.estado_pedido === "Pagada") return bill;
        return null;
      }).filter(function (el) {
        return el != null;
      });

      ordersToPayToDisplay = this.props.mainState.orders.slice(0).map(bill => {
        if (bill.estado_pedido !== "Pagada") return bill;
        return null;
      }).filter(function (el) {
        return el != null;
      });

      if (ordersToPayToDisplay.length > 0) {
        contentToPayToDisplay = 
          <Col xs={12}>
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Facturas pendientes de pago</CardTitle>
              </CardHeader>
              <CardBody>
                <Table responsive>
                  <thead>
                    <tr className="text-primary">
                      {thead.map((prop, key) => {
                        if (key === thead.length - 1)
                          return (
                            <th key={key} className="text-center">
                              {prop}
                            </th>
                          );
                        return <th key={key} className="text-center">{prop}</th>;
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {ordersToPayToDisplay.map((order, key) => {
                      let overcharge = "";
                      if (order.estado_pedido === "Recibo devuelto") {
                        overcharge = <span style={{color:"#e74c3c"}}><b> (+5€)</b></span>;
                      }
                      return (
                        <tr key={order.numero_pedido}>
                          <td className="text-center">{order.fecha}</td>
                          <td className="text-center">{order.numero_pedido}</td>
                          <td className="text-center">{order.total}{overcharge}</td>
                          <td className="text-center">    
                          {this.paymentStatus(order)} 
                          </td>
                          <td className="text-center">
                            {this.payButton(order)}
                            {" "}
                            <Button
                              color="danger"
                              size="sm"
                              onClick={e =>
                                this.downloadBill(order.enlace_pdf, order.numero_pedido, e)
                              }
                            >
                              {this.downloadButton(order.numero_pedido)}
                            </Button>{" "}
                            <Link to={"/facturas/".concat(order.numero_pedido)}>
                              <Button
                                color="info"
                                size="sm"
                                /* onClick={e =>
                                  this.viewOrderArticles(order.numero_pedido, e)
                                } */
                              >
                                <div>
                                  <i className="now-ui-icons education_glasses" /> Ver
                                </div>
                              </Button>
                            </Link>
                          </td>
                          {/* order.data.map((prop, key) => {
                            if (key === thead.length - 1)
                              return (
                                <td key={key} className="text-right">
                                  {prop}
                                </td>
                              );
                            return <td key={key}>{prop}</td>;
                          }) */}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>;
        arrayContentsToDisplay.push(contentToPayToDisplay);
      }

      let paymentInstructions = 
        <Col xs={12}>
          <Card color="warning">
            <CardHeader>
              <CardTitle tag="h4">Instrucciones para pagar un recibo devuelto mediante transferencia</CardTitle>
            </CardHeader>
            <CardBody>
              <div>
                <span>
                  Para llevar a cabo el pago de un recibo devuelto, tienes que contemplar el hecho de que cada recibo devuelto conlleva <b>un cargo de 
                  5€</b> por los gastos de gestión que ha ocasionado, por ejemplo, si la factura del recibo devuelto es de 20'95€ entonces la transferencia 
                  tiene que ser de 25'95€ (20'95€ + 5€). <br></br><br></br>
                  Las cuentas bancarias a las que puedes hacer las transferencias son:
                  <ul>
                    <li><b>(Sabadell)</b> ES35 0081 0416 4900 0163 3069</li>
                    <li><b>(BBVA)</b> ES55 0182 1810 7802 0162 4810</li>
                  </ul>
                  <b>No olvides indicar en el concepto el número de factura y tu DNI</b><br></br><br></br> 
                  A continuación, te indicamos las transferencias a realizar por los recibos devueltos:<br></br>
                  <b>MUY IMPORTANTE: envíanos el justificante de la transferencia a facturacion@nadunet.es</b>
                  <ul>
                    {facturasDevueltas.map(factura => {
                      let facturaElementoLista =
                      <li>
                        {"Factura nº " + factura.numero_pedido} ({factura.fecha})
                        <ul>
                          <li>
                            <b>Concepto: </b>{"DNI " + this.props.mainState.user.field_dni.und[0].value + " factura " + factura.numero_pedido}
                          </li>
                          <li>
                            <b>Importe: </b>{((parseFloat(factura.total.replace(/\s/g, '').replace("€", "").replace(",", ".")) + 5) + "€").replace(".", ",")} ({factura.total.replace(/\s/g, '') + " + 5€"})
                          </li>
                        </ul>
                      </li>;
                      return facturaElementoLista;
                    })}
                  </ul>
                  <br></br><br></br>
  
                </span>
              </div>
            </CardBody>
          </Card>
        </Col>;
      
      if (ordersToPayToDisplay.length > 0 && paymentInstructions) {
        arrayContentsToDisplay.push(paymentInstructions);
      }
      if (ordersToDisplay.length > 0) {
        contentToDisplay = 
          <Col xs={12}>
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Últimas facturas</CardTitle>
              </CardHeader>
              <CardBody>
                <Table responsive>
                  <thead>
                    <tr className="text-primary">
                      {thead.map((prop, key) => {
                        if (key === thead.length - 1)
                          return (
                            <th key={key} className="text-center">
                              {prop}
                            </th>
                          );
                        return <th key={key} className="text-center">{prop}</th>;
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {ordersToDisplay.map((order, key) => {
                      return (
                        <tr key={order.numero_pedido}>
                          <td className="text-center">{order.fecha}</td>
                          <td className="text-center">{order.numero_pedido}</td>
                          <td className="text-center">{order.total}</td>
                          <td className="text-center">    
                          {this.paymentStatus(order)} 
                          </td>
                          <td className="text-center">
                            <Button
                              color="danger"
                              size="sm"
                              onClick={e =>
                                this.downloadBill(order.enlace_pdf, order.numero_pedido, e)
                              }
                            >
                              {this.downloadButton(order.numero_pedido)}
                            </Button>{" "}
                            <Link to={"/facturas/".concat(order.numero_pedido)}>
                              <Button
                                color="info"
                                size="sm"
                                /* onClick={e =>
                                  this.viewOrderArticles(order.numero_pedido, e)
                                } */
                              >
                                <div>
                                  <i className="now-ui-icons education_glasses" /> Ver
                                </div>
                              </Button>
                            </Link>
                          </td>
                          {/* order.data.map((prop, key) => {
                            if (key === thead.length - 1)
                              return (
                                <td key={key} className="text-right">
                                  {prop}
                                </td>
                              );
                            return <td key={key}>{prop}</td>;
                          }) */}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>;
        arrayContentsToDisplay.push(contentToDisplay);
      }
      contentToDisplay = arrayContentsToDisplay; 
    } else if (this.props.mainState.ordersLoaded && this.props.mainState.orders.length == 0) {
      contentToDisplay =       
      <SweetAlert
      success
      style={{ display: "block", marginTop: "-250px" }}
      title="¡No tienes facturas!"
      onConfirm={() => this.goToDashboard()}
      onCancel={() => this.goToDashboard()}
      confirmBtnBsStyle="info"
    >
      Todavía no tienes ninguna factura, tan pronto como las tengas, aparecerán aquí.
    </SweetAlert>;
    } else {
      contentToDisplay = 
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title="¡Un momentito!"
        onConfirm={() => this.hideAlert()}
        showConfirm={false}
      >
        <i className="now-ui-icons arrows-1_refresh-69 spin" />
          {"  Cargando facturas..."}
      </SweetAlert>;
    }

    let orderArticles = 
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title="Detalles de la factura"
        onConfirm={() => this.hideDetail()}
        showConfirm={true}
      >
        {this.state.orderDetail}
      </SweetAlert>;
    return (
      <div>
        {paymentForm}
        <PanelHeader
          size="lg"
          content={
            <div>
              <h6 style={dashboardOrdersTitleStyle}>{this.state.ordersHistoryTitle}</h6>
            <Line
              data={!this.state.ordersChartReady? dashboardPanelChart.data : this.state.ordersChart.data}
              options={!this.state.ordersChartReady? dashboardPanelChart.options : this.state.ordersChart.options}
            />
            </div>
          }
        />
        <div className="content">
          {this.state.popUp}
          {/* {facturasDevueltas.length > 0 && paymentInstructions} */}
          <Row>
            {this.state.showDetail && orderArticles}
            {contentToDisplay}
          </Row>
        </div>
      </div>
    );
  }
}

export default BillsList;



// WEBPACK FOOTER //
// ./src/views/Bills/BillsList.jsx